export default "__VITE_ASSET__DNivUE1w__"